( function () {
	'use strict';

	/* @ngInject */
	function Ctrl ( logger, $scope, $attrs ) {
		var self   = this;

		self.title = 'Nav Tabs Ctrl';

		function setActive ( index ) {
			if ( index !== $scope.active ) {
				$scope.active = index;

				if ( $attrs.callback ) {
					$scope.callback( { 'value' : index } );
				}
			}
		}

		function activate () {
			logger.info( 'Nav Tabs Controller used.' );
		}

		self.setActive = setActive;

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'NavTabsCtrl', Ctrl );

	Ctrl.$inject = [ 'logger', '$scope', '$attrs' ];
} )();
